import { clsx } from 'external/clsx'
import Icon, { IconName } from 'external/fortawesome'
import {FC, CSSProperties, useRef, ComponentPropsWithRef, useEffect, useMemo} from 'external/react'
import { isEmpty } from 'utilities/text'

type LabeledIconProps =  ComponentPropsWithRef<'span'> & {
	label: string
	icon: IconName
	textOverflow?: 'ellipsis' | 'clip' | string
	hiddenIfEmpty?: boolean
	className?: string
	style?: CSSProperties
}

const LabeledIcon: FC<LabeledIconProps> = (props) => {
	const {label, icon,  style, className, hiddenIfEmpty = false, textOverflow, ref} = props 
	const [componentClassName, labelStyle] = useMemo(() => [
		clsx('d-inline-flex',
			{ 'd-none': hiddenIfEmpty && isEmpty(label),
			  'flex-nowrap': !!textOverflow,
			  'text-nowrap': !!textOverflow,
			  'overflow-hidden': !!textOverflow
			}),
			textOverflow ? {textOverflow, overflow: 'hidden'} : {}
	], [textOverflow, className, hiddenIfEmpty])
	return (
	<span ref={ref} className={componentClassName} style={style}>
		<span className={clsx('icon', 'mr-1')}><Icon name={icon} /></span>
		<span className={clsx('label', 'pl-1')} style={labelStyle} title={label}>{label}</span>
	</span>
	)

}

export {LabeledIcon as default}